<template>
  <div class="qr-code-scanner" :key="z">
    <div class="modal qr-scanner-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card" v-observe-visibility="visibilityChanged">
        <section class="modal-card-body">
          <div
            class="notification is-warning"
            :class="theme"
            @click="goto('/qrscanner')"
          >
            <span class="has-text-weight-medium is-size-5">
              <i v-if="!isResult" class="fas fa-spinner fa-spin" />
              {{ qrState }}
            </span>
            <i class="fa fa-gamepad fa-2x" @click="chooseSounds" />
          </div>
          <p v-show="error" class="error">{{ error }}</p>
          <div class="placeholder">
            <i class="fa fa-camera fa-3x" />
            <p style="margin-top: 16px; font-size: 1.2em">Opening Camera...</p>
          </div>
          <qrcode-stream
            @decode="onDecode"
            class="qr-reader"
            v-if="isVisible"
          ></qrcode-stream>
        </section>
      </div>

      <div v-if="isResult" class="url centered vcentered" @click="goToURL">
        <img src="../assets/new-logo-round-512.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import EventBus from "../eventBus.js";
import { sounds } from "../functions.js";

import VueQrcodeReader from "vue-qrcode-reader";

export default {
  name: "QRCodeScanner",
  // components: { VueQrcodeReader },
  data() {
    return {
      z: 0, // increment to reset, a hack that's not working...
      qrState: this.$t("qr.detecting"), //"Detecting QR Code...",
      result: "",
      isResult: false,
      error: "",
      isVisible: false,
      soundIdx: 0,
      unsafeSounds: [
        "unsafe",
        "navigate1",
        "navigate2",
        "mystery_short",
        "mystery_long",
        "parrot",
        "squawk",
        "servo",
      ],
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  created() {
    Vue.use(VueQrcodeReader);
  },
  mounted() {
    // should get unsafe soundIdx from store, and also save to store if changed
    this.soundIdx = this.$store.state.qrScannerSound;
  },
  methods: {
    closeModal() {
      this.isVisible = false; // turn off camera
      this.z += 1;
      this.$el.querySelector(".modal").classList.remove("is-active");
      this.isResult = false;
    },
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
      // this.console("visibilityChanged entry", entry);
    },
    goToURL(external) {
      if (!this.result.includes(".")) {
        alert("Not a valid URL!");
        this.closeModal();
        return;
      }
      if (external) window.open(this.result, "_blank");
      else window.location = this.result;
    },
    chooseSounds() {
      this.soundIdx += 1;
      if (this.soundIdx >= this.unsafeSounds.length) this.soundIdx = 0;
      this.$store.commit("setQRScannerSound", this.soundIdx);
      this.unsafeSound();
    },
    unsafeSound() {
      sounds(this.unsafeSounds[this.soundIdx]);
    },
    onDecode(result) {
      this.console("decoded qr code!", result);
      if (result === "") return;

      // unsafe link
      if (!this.isTUKQR(result)) {
        this.unsafeSound(); // sounds("unsafe");
        this.result = result;
        this.$swal({
          title: "Unknown QR Code",
          html: `Proceed at your own risk to:<br><strong><a>${result}</a></strong>`,
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Go anyway",
          cancelButtonText: "Cancel",
          cancelButtonColor: this.bulmaColor("info"),
          confirmButtonColor: this.bulmaColor("danger"),
          reverseButtons: true,
        }).then((result) => {
          if (result.value) this.goToURL(true);
          else if (result.dismiss === "cancel") this.closeModal();
          else this.z += 1;
        });
        return;
      }

      // safe link, automatically goes to URL after 1 sec delay
      sounds("safe"); // play safe QR code detected sound
      EventBus.$emit("DEBUG", "qr decoded: " + result);
      this.result = result;
      this.isResult = true;
      setTimeout(() => this.goToURL(), 1000);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
  },
};
</script>

<style scoped lang=scss>
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.url {
  /* background-color: rgba(39, 243, 243, 0.349); */
  padding: 20px;
  border-radius: 50%;
  box-shadow: 2px 2px 10px 10px rgba(39, 243, 243, 0.5);
}
.modal-card-body {
  width: 98vw;
  max-width: 640px;
  background-color: #123;
  padding: 3px;
  overflow: hidden;
  /* border-radius: 25px; */
}
.notification {
  position: absolute;
  padding: 5px 0;
  /* margin-bottom: 3px; */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 1;
  width: calc(98vw - 6px);
  max-width: calc(640px - 6px);
  /* margin-top: -3px; */
  /* margin-left: -3px; */
}
.qr-reader {
  height: 75vh;
  overflow: hidden;
  border-radius: 3px;
}
.dark.notification {
  background-color: #2693da;
}
.fa-spinner {
  margin-right: 4px;
}
.fa-gamepad {
  position: absolute;
  right: 12px;
  top: 5px;
  opacity: 0.8;
  color: white;
  text-shadow: 1px 1px 2px black;
}
.placeholder {
  position: absolute;
  margin-top: 37vh;
  text-align: center;
  width: 100%;
}
</style>